import React from 'react';
import { Box, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NoColorLink } from 'ui/NoColorLink';

type NoColorLinkProps = React.ComponentProps<typeof NoColorLink>;

const StyButton = styled(Box, {
    name: 'StyButton',
    shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<(NoColorLinkProps | ButtonProps) & { backgroundColor?: string }>(
    ({ theme, backgroundColor }) => ({
        display: 'flex',
        flexGrow: 1,
        color: 'black',
        backgroundColor: backgroundColor || theme.palette.common.white,
        '&:hover': {
            backgroundColor:
                backgroundColor === theme.palette.common.white ||
                !backgroundColor
                    ? theme.palette.primary.background
                    : backgroundColor,
            opacity: 0.5,
        },
    }),
);

export default StyButton;
